import { render } from "./AdminTestStorefront.vue?vue&type=template&id=0089de8d&scoped=true"
import script from "./AdminTestStorefront.vue?vue&type=script&lang=js"
export * from "./AdminTestStorefront.vue?vue&type=script&lang=js"

import "./AdminTestStorefront.vue?vue&type=style&index=0&id=0089de8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0089de8d"]])

export default __exports__